module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABNElEQVQoU2NkQAYN/9nEv36s/8/IEMLIwMDE+J9hA8ufz3VP+mW/w5QBxRFAvPTjBAaGf/kohjAyzH3ZJZiCoYG/4oMgx1+GZwwM/zmQNfxnYPz9n+GX3OtusRcgcbgNYuWfrBj//T2KYjqM85/R+WWPwD5UDaUf3BgZ/u/EqoGJ2e9lJ99mFA0yhR+FfrP8ew4UZEN3EgPrT9lXbeIvUTSAOOKl74GeZkDx9H9GxmmvugSysYdSyUdzBsZ/J1Cc9Z/J4mUP/0kUDSKl7+2ZGRiCgWHgBQwlZTR/3AMGzTag3IaXXQJ7GcXLPiQz/GeYDVSIEifYPA8M4nRGsdJ3NxgZGNWxhg6GION1RpHSD0bMDIxxQBu0gfJiQFoA6ARWsNr/DL+B5AcGRsaXQAdc+f+feQEAlSxf7N0eU2UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pe.png
// module id = nL43
// module chunks = 15